import SignUpForm from 'components/LoginSignUp/SignUpForm';
import React, { Component } from 'react';

interface SignUpFormContainerProps {
  handleSubmit: (data: {
    email: string;
    password: string;
    gender?: 'man' | 'woman' | 'other';
    firstname: string;
    lastname: string;
    country?: string;
    phoneCountryCode?: string;
    phoneNumber?: string;
  }) => void;
  countries: any[];
  options?: {
    gender?: boolean;
    firstname?: boolean;
    lastname?: boolean;
    country?: boolean;
    phoneCountryCode?: boolean;
    phoneNumber?: boolean;
  };
  signupButtonLoading: boolean;
}

interface SignUpFormContainerState {
  email: string;
  password: string;
  gender: undefined | 'man' | 'woman' | 'other';
  firstname: string;
  lastname: string;
  country: string;
  phoneCountryCode: string;
  phoneNumber: string;
  phoneCountryCodeManuallySet: boolean;
  [key: string]: any;
}

class SignUpFormContainer extends Component<
  SignUpFormContainerProps,
  SignUpFormContainerState
> {
  state = {
    email: '',
    password: '',
    gender: null,
    firstname: '',
    lastname: '',
    country: 'United States',
    phoneCountryCode: '1',
    phoneNumber: '',
    phoneCountryCodeManuallySet: false,
  };

  getInputValue = (target: any) => {
    switch (target.type) {
      case 'checkbox':
        return target.checked;
      default:
        return target.value;
    }
  };

  onChange = (event: any) => {
    const target = event.target;
    const value = this.getInputValue(target);
    const name = target.name;

    // If the country+country_code nr was set
    if (name === 'phoneCountryCode') {
      const [callingCode, country] = value.split('_');
      if (!!country) {
        this.setState({
          phoneCountryCode: callingCode,
          country: country,
        });
        return;
      }
    }

    // If country was changed and the calling code has not been set already, set the calling code from the country
    if (name === 'country' && !this.state.phoneCountryCodeManuallySet) {
      const country = this.props.countries.find((c) => c.name === value);
      if (!!country) {
        this.setState({
          phoneCountryCode: country.callingCode,
        });
        return;
      }
    }

    this.setState({
      [name]: value,
    });
  };

  onSubmit = (event: any) => {
    event.preventDefault();
    this.props.handleSubmit(this.state);
  };

  phoneCountryCodeClick = () => {
    this.setState({ phoneCountryCodeManuallySet: true });
  };

  render() {
    return (
      <SignUpForm
        signupButtonLoading={this.props.signupButtonLoading}
        countries={this.props.countries}
        onSubmit={this.onSubmit}
        onChange={this.onChange}
        onPhoneCountryCodeClick={this.phoneCountryCodeClick}
        options={this.props.options}
        country={this.state.country}
        email={this.state.email}
        firstname={this.state.firstname}
        lastname={this.state.lastname}
        password={this.state.password}
        gender={this.state.gender}
        phoneCountryCode={`${this.state.phoneCountryCode}_${this.state.country}`}
        phoneNumber={this.state.phoneNumber}
      />
    );
  }
}

export default SignUpFormContainer;
